// src/components/America250Banner.tsx
import React from "react";
import { useTheme } from "../contexts/ThemeContext";

/**
 * Sitewide celebration banner for America's 250th Birthday.
 * Renders only when the "america250" theme is active (June 6 – July 31, 2026).
 * Styled via .america250-banner rules in App.css using the theme's CSS vars.
 */
const America250Banner: React.FC = () => {
  const { activeTheme } = useTheme();

  if (activeTheme.id !== "america250") return null;

  return (
    <div
      className="america250-banner"
      role="banner"
      aria-label="America's 250th Birthday celebration"
    >
      <div className="america250-banner__inner">
        <span className="america250-banner__stars" aria-hidden="true">
          ★ ★ ★
        </span>
        <div className="america250-banner__text">
          <span className="america250-banner__title">
            Celebrating America&rsquo;s 250th Birthday &mdash; 10% Off Sitewide!
          </span>
          <span className="america250-banner__subtitle">
            Use code <strong translate="no">AMERICA250</strong> at checkout
            &mdash; valid June &amp; July 2026 only &nbsp;&middot;&nbsp; July 4,
            1776 &nbsp;&middot;&nbsp; July 4, 2026
          </span>
        </div>
        <span className="america250-banner__stars" aria-hidden="true">
          ★ ★ ★
        </span>
      </div>
    </div>
  );
};

export default America250Banner;
